module.exports = __webpack_public_path__ + "static/media/TRANSPORT WITH US.dca43ac5.jpg";